import React from 'react'
import PropTypes from 'prop-types'
import { NavItem, NavLink } from 'components/qstrap'

const MobileMenuToggler = ({ drawerId, hidden, dropdownOnClick }) => (
  <NavItem className="hidden-lg-up" hidden={hidden}>
    <NavLink toggler dataToggle="drawer" dataTarget={drawerId} onClick={dropdownOnClick}>
      <span className="navbar-toggler-bar" />
    </NavLink>
  </NavItem>
)

MobileMenuToggler.propTypes = {
  drawerId: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  dropdownOnClick: PropTypes.func,
}

export default MobileMenuToggler
